import React from 'react'

export const ReactLegendMap = () => {
    const grades = ["High", "Moderate", "Low"];
    const colors = ["green", "yellow", "red"];
  
    return (
      <div className="custom-legend-project">
        <h6 style={{ marginBottom: "10px" }}>Legend</h6>
        {grades.map((grade, i) => (
          <div className="legend-item" key={i}>
            <div
              className="legend-color"
              style={{ backgroundColor: colors[i] }}
            ></div>
            <span>{grade}</span>
          </div>
        ))}
      </div>
    );
}
